import { SocialPublishAtField } from '@app/modules/social-export/components/inputs/SocialPublishAtField';
import { BaseExportFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { FormSection } from '@app/core/components/FormSection';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid, Stack } from '@mui/material';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { DemoPublishValues, useDemoPublishSchema } from './useDemoPublishSchema';

type DemoPublishFormProps = BaseExportFormProps<any, socialExport.DemoSettingsDto>;

export function DemoPublishForm({
  source,
  onUpload,
  actions,
}: DemoPublishFormProps) {
  const { $t } = useIntl();
  const schema = useDemoPublishSchema();
  const initialValues: DemoPublishValues = {
    title: source.title ?? '',
    description: source.description ?? '',
    publishAt: null,
  };

  return (
    <FormContainer
      values={initialValues}
      mode="onBlur"
      resolver={zodResolver(schema)}
      onSuccess={async (formData) => {
        await onUpload(formData);
      }}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.demoData',
          defaultMessage: 'Datos de demo',
        })}
      >
        <Stack spacing={3}>
          <TextFieldElement
            name="title"
            label={$t({
              id: 'socialExport.form.title',
              defaultMessage: 'Título',
            })}
            required
            fullWidth
          />
          <TextFieldElement
            name="description"
            label={$t({
              id: 'socialExport.form.description',
              defaultMessage: 'Descripción',
            })}
            required
            fullWidth
            multiline
            rows={3}
          />
        </Stack>
      </FormSection>
      <FormSection
        title={$t({
          id: 'socialExport.form.schedule',
          defaultMessage: 'Programación',
        })}
      >
        <Grid container>
          <Grid item md={12}>
            <SocialPublishAtField />
          </Grid>
        </Grid>
      </FormSection>
      {actions}
    </FormContainer>
  );
}
